export const taskArrSupport = [
  'APP_FOR_TITLE',
  'CONTACT_LIENHOLDER',
  'UPDATE_LIENHOLDER_INFO',
  'DRIVER_LICENSE',
  'LOSS_PAYEE',
  'RECEIVE_APP_FOR_TITLE',
]

export const taskArrUnderwriting = [
  'PROOF_OF_EMPLOYMENT',
  'PROOF_OF_INSURANCE',
  'REVIEW_OFAC',
  'SIGN_LOAN_AGREEMENT',
  'SUBMIT_PROOF_OF_INCOME',
  'VERIFY_MILEAGE',
  'CURRENT_MORTGAGE_STATEMENT',
  'SSN_CARD',
]

export const taskArrFraud = [
  'CARFAX_FRAUD_REVIEW',
  'HANDLE_INSUFFICIENT_FUNDS',
  'REVIEW_FOR_FRAUD',
  'REVIEW_STATEMENT',
  'VERIFY_FUNDS',
  'REVIEW_USER_DATA_MISMATCH',
  'REVIEW_PLAID_DATA_MISMATCH',
]

export const taskArrTitle = [
  'HANDLE_TITLE',
  'RECEIVE_LPOA',
  'RECEIVE_SPOA',
  'REGISTRATION',
  'SEND_BUYER_PACKET',
  'SEND_FUNDS_TO_LIENHOLDER',
  'SEND_SPOA_TO_SELLER',
  'TITLE',
]

export const taskTypes = [
  {
    label: 'App for Title',
    value: 'APP_FOR_TITLE',
    requiredBadge: ['app_for_title'],
    taskBucket: 'SUPPORT_ALL',
  },
  {
    label: 'Contact Lienholder',
    value: 'CONTACT_LIENHOLDER',
    requiredBadge: ['contact_lienholder'],
    taskBucket: 'SUPPORT_ALL',
  },
  {
    label: 'Update Lienholder Info',
    value: 'UPDATE_LIENHOLDER_INFO',
    requiredBadge: ['update_lienholder_info'],
    taskBucket: 'SUPPORT_ALL',
  },
  {
    label: 'Driver License',
    value: 'DRIVER_LICENSE',
    requiredBadge: ['driver_license'],
    taskBucket: 'SUPPORT_ALL',
  },
  {
    label: 'Loss Payee',
    value: 'LOSS_PAYEE',
    requiredBadge: ['loss_payee'],
    taskBucket: 'SUPPORT_ALL',
  },
  {
    label: 'Receive App for Title',
    value: 'RECEIVE_APP_FOR_TITLE',
    requiredBadge: ['receive_app_for_title'],
    taskBucket: 'SUPPORT_ALL',
  },
  {
    label: 'Proof of Employment',
    value: 'PROOF_OF_EMPLOYMENT',
    requiredBadge: ['proof_of_employment'],
    taskBucket: 'UNDERWRITING_ALL',
  },
  {
    label: 'Proof of Insurance',
    value: 'PROOF_OF_INSURANCE',
    requiredBadge: ['proof_of_insurance'],
    taskBucket: 'UNDERWRITING_ALL',
  },
  {
    label: 'Mortgage Statement',
    value: 'CURRENT_MORTGAGE_STATEMENT',
    requiredBadge: ['current_mortgage_statement'],
    taskBucket: 'UNDERWRITING_ALL',
  },
  {
    label: 'SSN Card',
    value: 'SSN_CARD',
    requiredBadge: ['ssn_card'],
    taskBucket: 'UNDERWRITING_ALL',
  },
  {
    label: 'Review OFAC',
    value: 'REVIEW_OFAC',
    requiredBadge: ['review_ofac'],
    taskBucket: 'UNDERWRITING_ALL',
  },
  {
    label: 'Sign Loan Agreement',
    value: 'SIGN_LOAN_AGREEMENT',
    requiredBadge: ['sign_loan_agreement'],
    taskBucket: 'UNDERWRITING_ALL',
  },
  {
    label: 'Submit Proof of Income',
    value: 'SUBMIT_PROOF_OF_INCOME',
    requiredBadge: ['submit_proof_of_income'],
    taskBucket: 'UNDERWRITING_ALL',
  },
  {
    label: 'Verify Mileage',
    value: 'VERIFY_MILEAGE',
    requiredBadge: ['verify_mileage'],
    taskBucket: 'UNDERWRITING_ALL',
  },
  {
    label: 'Carfax Fraud Review',
    value: 'CARFAX_FRAUD_REVIEW',
    requiredBadge: ['carfax_fraud_review'],
    taskBucket: 'FRAUD_ALL',
  },
  {
    label: 'Handle Insufficient Funds',
    value: 'HANDLE_INSUFFICIENT_FUNDS',
    requiredBadge: ['handle_insufficient_funds'],
    taskBucket: 'FRAUD_ALL',
  },
  {
    label: 'Review for Fraud',
    value: 'REVIEW_FOR_FRAUD',
    requiredBadge: ['review_for_fraud'],
    taskBucket: 'FRAUD_ALL',
  },
  {
    label: 'Review Statement',
    value: 'REVIEW_STATEMENT',
    requiredBadge: ['review_statement'],
    taskBucket: 'FRAUD_ALL',
  },
  {
    label: 'Verify Funds',
    value: 'VERIFY_FUNDS',
    requiredBadge: ['verify_funds'],
    taskBucket: 'FRAUD_ALL',
  },
  {
    label: 'Verify Data',
    value: 'REVIEW_USER_DATA_MISMATCH',
    requiredBadge: ['REVIEW_USER_DATA_MISMATCH'],
    taskBucket: 'FRAUD_ALL',
  },
  {
    label: 'Verify Plaid',
    value: 'REVIEW_PLAID_DATA_MISMATCH',
    requiredBadge: ['REVIEW_PLAID_DATA_MISMATCH'],
    taskBucket: 'FRAUD_ALL',
  },
  {
    label: 'Handle Title',
    value: 'HANDLE_TITLE',
    requiredBadge: ['handle_title'],
    taskBucket: 'TITLE_ALL',
  },
  {
    label: 'Receive LPOA',
    value: 'RECEIVE_LPOA',
    requiredBadge: ['receive_lpoa'],
    taskBucket: 'TITLE_ALL',
  },
  {
    label: 'Receive SPOA',
    value: 'RECEIVE_SPOA',
    requiredBadge: ['receive_spoa'],
    taskBucket: 'TITLE_ALL',
  },
  {
    label: 'Registration',
    value: 'REGISTRATION',
    requiredBadge: ['registration'],
    taskBucket: 'TITLE_ALL',
  },
  {
    label: 'Send Buyer Packet',
    value: 'SEND_BUYER_PACKET',
    requiredBadge: ['send_buyer_packet'],
    taskBucket: 'TITLE_ALL',
  },
  {
    label: 'Send Funds to Lienholder',
    value: 'SEND_FUNDS_TO_LIENHOLDER',
    requiredBadge: ['send_funds_to_lienholder'],
    taskBucket: 'TITLE_ALL',
  },
  {
    label: 'Send SPOA to Seller',
    value: 'SEND_SPOA_TO_SELLER',
    requiredBadge: ['send_spoa_to_seller'],
    taskBucket: 'TITLE_ALL',
  },
  {
    label: 'Title',
    value: 'TITLE',
    requiredBadge: ['title'],
    taskBucket: 'TITLE_ALL',
  },
]
